// Copyright (c) 2016 Deere & Company

import {applyMiddleware, compose, createStore} from 'redux';
import {hashHistory} from 'react-router';
import {routerMiddleware} from 'react-router-redux';
import thunk from 'redux-thunk';

export const create = reducers => {

    const router = routerMiddleware(hashHistory);

    /* istanbul ignore next */

    /* eslint-disable no-underscore-dangle */

    const middlewareStoreCreator = compose(
        applyMiddleware(thunk),
        applyMiddleware(router),
        window.__REDUX_DEVTOOLS_EXTENSION__ ?
            window.__REDUX_DEVTOOLS_EXTENSION__() :
            f => f
    )(createStore);

    /* eslint-enable no-underscore-dangle */

    return middlewareStoreCreator(reducers);

};



// WEBPACK FOOTER //
// ./src/store-configurator.js